export default "__VITE_ASSET__Dm_po0jm__"